import React from "react";

const NotFound = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        margin: "20px",
        justifyContent: "center",
      }}
    >
      <h1>404 Not Found!</h1>
    </div>
  );
};

export default NotFound;
